import LocalStorage from "../services/localStorage";
import store from "../store";
import {SnackbarProgrammatic as Snackbar} from 'buefy';
import axios from "axios";

// This is used to send images along with a payload to the api.
/**
 *
 * NOTE:
 *
 *      !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *      !!!!!!!    Only Works With post requests        !!!!!!!
 *      !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 */
export function objectToFormData(obj, form, namespace) {
  let fd = form || new FormData();
  let formKey;

  for (let property in obj) {
    if (obj.hasOwnProperty(property)) {

      if (namespace) {
        formKey = namespace + '[' + property + ']';
      } else {
        formKey = property;
      }

      // if the property is an object, but not a File,
      // use recursivity.
      if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {

        objectToFormData(obj[property], fd, property);
      } else {

        // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }

    }
  }

  return fd;
}


function http(validationErrors = {}) {
  axios.defaults.withCredentials = true;

  store.dispatch('apiCallMade');

  const httpInstance = axios.create({
    baseURL: process.env.MIX_BASE_API_URL,
    headers: {
      'Authorization': `Bearer ${LocalStorage.getApiToken()}`
    }
  });

  httpInstance.interceptors.response.use(
    response => successHandler(response, validationErrors),
    error => errorHandler(error, validationErrors),
  );

  return httpInstance;
}

const successHandler = (response, validationErrors) => {
  if (response.data.clientStoreChanges) {
    response.data.clientStoreChanges.forEach(change => {
      store.dispatch('pusherEvent', change);
    });

    delete response.data.clientStoreChanges;
  }

  Object.keys(validationErrors).forEach((key) => {
    delete validationErrors[key];
  })

  if (response.data.responseData) {
    response.data = response.data.responseData;
  }

  if (response && response.status === 202) {
    const message = (response.data.message) ? response.data.message : response.data
    Snackbar.open({
      message: message,
      type: 'is-success',
      position: 'is-bottom',
      indefinite: true
    });
  }

  return response;
};

const errorHandler = (error, validationErrors) => {
  // Where getting a sentry issue because we're processing this error when it doesn't exist.
  // The assumption is that the server is timing out and not sending an error
  if(!error) {
    return Promise.reject('No error from server')
  }

  if (error.response && error.response.data && error.response.data.responseData) {
    error.response.data = error.response.data.responseData;
  }

  // Bypass Error Handling
  if (error.response && error.response.status === 420) {
    return Promise.reject({ ...error })
  }

  if (error.response && error.response.status === 429) {
    const message = (error.response.data.message) ? error.response.data.message : error.response.data
    Snackbar.open({
      message: message,
      type: 'is-warning',
      position: 'is-bottom',
      indefinite: true
    });

    return Promise.reject({ ...error })
  }

  if (error.response && error.response.status === 430) {
    const message = (error.response.data.message) ? error.response.data.message : error.response.data
    Snackbar.open({
      message: message,
      type: 'is-danger',
      position: 'is-bottom',
      indefinite: true
    });

    return Promise.reject({ ...error })
  }

  if (error.response && error.response.status === 422) {
    Object.keys(error.response.data.errors).forEach((key) => {
      validationErrors[key] = error.response.data.errors[key];
    })

    return Promise.reject({ ...error, ...validationErrors })
  }

  if (error.response && error.response.status === 426) {
    Snackbar.open({
      message: 'We’ve made changes to Forefront recently, please refresh your page to get the latest changes',
      type: 'is-warning',
      indefinite: true,
      actionText: 'Refresh',
      position: 'is-bottom',
      onAction() {
        location.reload()
      }
    });

    return Promise.reject({ ...error })
  }

  if (error.response && (error.response.status === 401 || error.response.status === 419 || error.response.status === 403)) {
    store.commit('setSessionTimeout', 0)
    return Promise.reject({ ...error })
  }

  if (error.response && error.response.status === 504) {
    Snackbar.open({
      message: 'Server Timeout: data set is too large',
      type: 'is-danger',
      position: 'is-bottom',
      indefinite: true
    });

    return Promise.reject({ ...error })
  }

  /*
    So these are all the error responses that our API throws
    And we will do the old thing we do, show a Snackbar at the bottom of the page
    But we need to refactor this one, initial fix at the moment

    Error responses that are not listed here will be handled inside a vue component
  */
  const apiResponses = [
    400,
    // 402, Used for Paused and Canceled Accounts
    404,
    409,
    416,
    419,
    429,
    500,
    519,
  ];

  if (error.response && apiResponses.includes(error.response.status)) {
    const message = (error.response && error.response.data.message) ? error.response.data.message : error.response.data
    Snackbar.open({
      message: message,
      type: 'is-danger',
      position: 'is-bottom',
      indefinite: true
    });

    return Promise.reject({ ...error })
  }

  /*
    Need remove this so that we have an option to handle error responses
    inside a vue component not just 422 error response
  */
  /* if (error.response.status !== 422) {
    Snackbar.open({
      message: error.response.data.message,
      type: 'is-danger',
      position: 'is-bottom',
      indefinite: true
    });

    return Promise.reject({ ...error })
  } */

  return Promise.reject({ ...error })
};

export default http;
